const FamtourDetailSkeleton = () => {
  return (
    <div className="px-5 mt-6 min-w-full animate-pulse">
      {/* Top Navigation & Title */}
      <div className="flex w-full items-center">
        <div className="w-1/12">
          <div className="w-8 h-8 bg-gray-200 rounded" />
        </div>
        <div className="w-9/12 flex justify-center">
          <div className="h-5 w-1/2 bg-gray-200 rounded" />
        </div>
        <div className="w-1/12 flex justify-end">
          <div className="w-6 h-6 bg-gray-200 rounded-full" />
        </div>
      </div>

      {/* Application Info Box */}
      <div className="bg-gray-100 p-5 rounded-lg flex flex-col gap-3 text-xs mt-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex items-center">
            <div className="w-3/12">
              <div className="h-4 bg-gray-200 rounded w-2/3" />
            </div>
            <div className="w-9/12">
              <div className="h-4 bg-gray-200 rounded w-full" />
            </div>
          </div>
        ))}
      </div>

      {/* Banner Images */}
      <div className="overflow-x-auto flex h-[180px] gap-3 w-full mt-5">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="w-40 h-40 bg-gray-200 rounded-xl flex-shrink-0" />
        ))}
      </div>

      {/* Planner Info */}
      <div className="flex justify-between items-start w-full px-3 py-5 border-b mt-5">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-full bg-gray-200" />
          <div className="w-24 h-4 bg-gray-200 rounded" />
        </div>
        <div className="w-28 h-6 rounded-full bg-gray-200" />
      </div>

      {/* Campaign Summary */}
      <div className="border-b pb-7 pl-3 mt-4">
        <div className="h-5 w-28 bg-gray-200 rounded mb-4" />
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex flex-col space-y-3 mb-4">
            <div className="flex justify-between items-start">
              <div className="flex items-center gap-4">
                <div className="w-[21px] h-[21px] rounded-full bg-gray-200" />
                <div className="h-4 w-24 bg-gray-200 rounded" />
              </div>
              <div className="h-3 w-16 bg-gray-200 rounded" />
            </div>
            <div className="flex gap-4 pl-6 pb-1 ml-[10px] border-l-2 border-gray-200">
              <div className="w-[111px] h-[96px] bg-gray-200 rounded-md" />
              <div className="flex flex-col gap-2 w-full">
                <div className="h-4 bg-gray-200 w-3/4 rounded" />
                <div className="h-4 bg-gray-200 w-full rounded" />
                <div className="h-4 bg-gray-200 w-5/6 rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Map Section */}
      <div className="flex flex-col gap-2 mt-7 border-b pb-9">
        <div className="w-full h-[150px] bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export default FamtourDetailSkeleton;
